import * as React from "react";
import {observer, inject} from "mobx-react";
//import FadeIn from "@utils/Fadein";
import FadeIn from "react-lazyload-fadein";
import classnames from "classnames";
import getBoxPadUrl from "@utils/getBoxPadUrl";
import isRetina from "is-retina";
//import ProductOrderlines from "@components/Order/ProductOrderlines";
import {QuantityEdit} from "./QuantityEdit";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import debounce from '@utils/debounce';

@inject("store")
@observer
export default class ProductCard extends React.Component {
    constructor(props) {
        super(props);
        this.increaseQuantities = this.increaseQuantities.bind(this);
        this.commitQuantity = debounce(this.commitQuantity.bind(this), 600);
        this.addQuantity = this.addQuantity.bind(this);
        this.openProductDialog = this.openProductDialog.bind(this);
        this.getProductUrl = this.getProductUrl.bind(this);
        this.toggleFavorite = this.toggleFavorite.bind(this);

        const orderlines = this.props.product && this.props.store.order.activeOrder && this.props.store.order.activeOrder.OrderLinesBySku(this.props.product.Sku, this.props.product.VariantSku);
        const quantity = orderlines && orderlines.length > 0 ? orderlines[0].Quantity : 0;

        const packSize = parseInt(this.props.product.PropertyByKey("PackSize"));
        const increments = isNaN(packSize) ? 1 : packSize;

        this.state = {
            hoverActive: false,
            sku: this.props.product.Sku,
            variantSku: this.props.product.VariantSku,
            increments: increments,
            adding: false,
            updating: false,
            quantity: quantity,
            orderQuantity: quantity,
            activeVariant: [] // [{GroupKey:"ColorId","GroupValue", "099"},...]
        }
    }


    toggleFavorite() {
        const stiStore = this.props.store.sti;
        const product = this.props.product;
        stiStore.toggleFavorite(this.state.sku).then(res => {
            if (res) {
                product.AddTag("Favorite");
            } else {
                product.RemoveTag("Favorite");
            }
        });

    }

    addQuantity(e, amount) {
        e.stopPropagation();
        e.preventDefault();
        this.setState({quantity: this.state.quantity + amount});
        this.commitQuantity();
    }

    commitQuantity(event) {

        //const activeOrder = this.props.store.order.activeOrder;

        const changes =
            [
                {
                    OrderLineId: -1,
                    Sku: this.state.sku,
                    VariantSku: this.state.variantSku,
                    OriginalQuantity: this.state.quantity
                }
            ];

        if (this.state.quantity === this.state.orderQuantity) {
            return;
        }

        this.setState({updating: true});

        this.props.store.order.updateQuantities(changes);

        // if(!activeOrder) {
        //     this.props.store.order.updateQuantities(changes);
        // }
        // else {
        //     activeOrder.updateQuantities(changes);    
        // }
    }


    getProductUrl(product, groupByValue) {
        return this.props.navigation.getProductUrl(product, groupByValue);
    }

    openProductDialog(e, product, listIndex, variantOptions) {
        console.debug("openProductDialog", variantOptions);
        e.preventDefault();
        this.props.navigation.openProductDialog(product, {listIndex: listIndex, variantOptions: variantOptions});
    }

    increaseQuantities(e, changes) {
        e.preventDefault();
        clearTimeout(this.timer);
        this.setState({adding: changes[0].Sku});
        const orderStore = this.props.orderStore;
        const result = orderStore.increaseQuantities(changes);

        this.timer = setTimeout(() => {
                this.setState({adding: null});
            },
            2000);
    }

    toggleCard(e, props) {
        this.setState(props);
        e.stopPropagation();
        e.preventDefault();
        
        return false;
    }

    getSize(product) {
        var keys = Object.keys(product.Properties);
        var sizeKey = keys.find(x => x.indexOf("Size") > -1);
        if (sizeKey) {
            var sizeVal = product.Properties[sizeKey];
            if (Array.isArray(sizeVal)) {
                return sizeVal[0];
            } else {
                return sizeVal;
            }
        }
        return null;
    }


    getColor() {

    }

    componentWillReact() {
        // console.log("STATE",JSON.stringify(this.state));
        //
        // const orderlines = this.props.store.order && this.props.store.order.activeOrder && this.props.store.order.activeOrder.OrderLinesBySku(this.state.sku, this.state.variantSku);
        // const quantity = orderlines != null && orderlines.length > 0 ? orderlines[0].Quantity : 0;
        //
        //
        // //console.log("componentWillReact ", orderlines, this.state.sku, this.state.variantSku, this.state.orderQuantity, quantity);
        // if (quantity !== this.state.orderQuantity) {
        //     this.setState({quantity: quantity, orderQuantity: quantity, updating: false});
        // }


    }

    render() {
        //console.log("PrdocutCard > Render", JSON.stringify(this.props.store.order));
        // const orderlines = this.props.store.order && this.props.store.order.activeOrder && this.props.store.order.activeOrder.OrderLinesBySku(this.state.sku, this.state.variantSku);
        // const quantity = orderlines && orderlines.length > 0 ? orderlines[0].Quantity : 0;

        const retina = isRetina();
        const imageWidth = this.props.imageWidth;
        const imageHeight = imageWidth;

        const thumbHeight = 70 * (retina ? 2 : 1);
        const thumbWidth = thumbHeight;
        const product = this.props.product;
        //console.log("product:", product);
        const inStock = product ? product.Stock.length > 0 && product.Stock[0].Quantity > 0 : false;
        const listIndex = this.props.listIndex || 0;
        const navigation = this.props.navigation;


        const groupByFilter = product.GroupByKeys.map((group, groupIndex) => {
            const variantGv = product.Properties[group];
            var t = {
                GroupKey: group,
                GroupValue: variantGv
            }
            return t;
        });

        const groupByArray = groupByFilter.map(g => {
            return g.GroupValue;
        });


        const firstGroup = (product.NewVariantGroups && product.NewVariantGroups.length > 0)
            ? product.NewVariantGroups[0]
            : {Items: [], GroupKey: null};

        const groupByKey = firstGroup.GroupKey;
        const filteredVariants = firstGroup.Items || [];
        const sortedVariants = filteredVariants.sort((a, b) => a.SortOrder - b.SortOrder);


        const activeVariant = this.state.activeVariant.length > 0 // todo: reimplment-> && this.state.activeVariant[0].GroupKey === groupByKey // Are we filtering on the same key?
            ? filteredVariants.find(x => x.GroupKey === this.state.activeVariant[0].GroupValue)// use client touch/mouseover override
            : sortedVariants.length > 0 ? sortedVariants[0] : null;   // Use serverside sort
        const groupByValue = activeVariant ? ("" + activeVariant.GroupKey) : "";
        const groupName = activeVariant && activeVariant.GroupName || "";


        //const groupByValue = activeVariant ? ("" + activeVariant.GroupKey) : "";

        const colorFilter = groupByFilter.find(x => x.GroupKey === "ColorId");
        const activeColorItem = (colorFilter && activeVariant)
            ? navigation.colors.find(x => x.ColorId === activeVariant.Properties[colorFilter.GroupKey])
            : null;

        //(groupByKey === "ColorId" && activeVariant)
        //? navigation.colors.find(x => x.ColorId === activeVariant.GroupKey)
        //: null;


        const primaryImageUrl = (activeVariant && activeVariant.Images.length > 0)
            ? activeVariant.Images[0]
            : product.PrimaryImageUrl;

        const currentUrlSlug = activeVariant ? activeVariant.GroupUrlSlug
            : product.UrlSlug;

        const productBrand = product.PropertyByKey("f_Brand");

        const productName = product.DisplayName;
        const productSku = product.VariantSku || product.Sku;

        // if (this.getSize(product) || product.PropertyByKey("ColorDesc")) {
        //
        //     productInfo += this.getSize(product) ? this.getSize(product) : "";
        //     productInfo += ((this.getSize(product) && product.PropertyByKey("ColorDesc")) ? "," : "") + (product.PropertyByKey("ColorDesc") ? product.PropertyByKey("ColorDesc") : "");
        // }

        const productStock = product.Stock.find(x => x.Sku === product.Sku);
        const productStockQuantity = (productStock && productStock.Quantity) || 0;
        
        const stockStatus  = product.PropertyByKey("StockStatus");

        let textAddButton = "Lägg till";
        let addButtonEnabled = true;
        switch (stockStatus) {
            case "PreBook":
                if(navigation.isD2C) {
                    textAddButton = "Kommer snart";
                    addButtonEnabled = false;
                }
                else {
                    textAddButton = "Förboka";    
                }
                
                break;
            case  "OutOfStock":
                textAddButton = "Slut för säsong";
                addButtonEnabled = false;
                break;
            case "TemporaryOutOfStock":
                textAddButton = "Kommer snart";
                addButtonEnabled = false;
                break;
        }

        const hoverDescription = (product.ShortDescription || "").split(/\r\n\r\n|\n\n|\r\r/)[0]; // split at double line breaks and take the first section

        return (

            <React.Fragment>
                <a
                    className={"product-wrapper " + (this.state.hoverActive ? "hover-active" : "")}
                    href={this.getProductUrl(product, currentUrlSlug)} onClick={(e) => {
                    this.openProductDialog(e,
                        product,
                        listIndex,
                        currentUrlSlug);
                        }}
                    onMouseEnter={(e) => {
                        !navigation.deviceIsTouchEnabled && this.toggleCard(e, {hoverActive: true, eventType: 'onMouseOver'});
                    }}
                    onMouseLeave={(e) => {
                        !navigation.deviceIsTouchEnabled && this.toggleCard(e, {hoverActive: false, activeVariant: [], eventType: 'onMouseLeave'});
                    }}
                >
                    <div className="product-card-inner">

                        {(product.Ads && product.Ads.length > 0) &&
                            <span className="product-card-ad" style={
                                product.Ads[0].Colour !== "" ? {backgroundColor: product.Ads[0].Colour} : {}}><span
                                className="text">{
                                product.Ads[0].Text}</span></span>
                        }

                        <img
                            alt={productName}
                            height={imageWidth}
                            width={imageWidth}
                            src={primaryImageUrl !== ""
                                ? getBoxPadUrl(primaryImageUrl, imageWidth, imageHeight, navigation.ImageFormat, "ffffff").url
                                : "/dist/img/no_image.jpg"}
                            
                            loading={"lazy"}
                        />
                        <div className="product-card-short-description">
                            <div className="product-card-short-description-inner">{hoverDescription}</div>
                        </div>

                        {/*<FadeIn*/}
                        {/*    ssr={navigation.ServerRender || this.props.ssr || this.props.disableLacyLoad}*/}
                        {/*    duration={350}*/}
                        {/*    heigh={800}*/}
                        {/*    offset={800}*/}
                        {/*    productImpression={true}*/}
                        {/*    product={product}*/}
                        {/*    listPosition={listIndex + 1}*/}
                        {/*    analytics={this.props.store.analytics}*/}
                        {/*    className={"product-image"}*/}
                        {/*>*/}
                        {/*    {onload => (*/}
                        {/*        <img*/}
                        {/*            alt={productName}*/}
                        {/*            height={imageWidth}*/}
                        {/*            width={imageWidth}*/}
                        {/*            src={primaryImageUrl !== ""*/}
                        {/*                ? getBoxPadUrl(primaryImageUrl, imageWidth, imageHeight, navigation.ImageFormat, "ffffff").url*/}
                        {/*                : "/dist/img/no_image.jpg"}*/}
                        {/*            onLoad={onload}/>*/}
                        {/*    )}</FadeIn>*/}

                        {/*<div className="product-card-siblings-hint"*/}
                        {/*     onClick={(e) => {*/}
                        {/*         this.toggleCard(e, {hoverActive: true, eventType: 'onClick'});*/}
                        {/*         return false;*/}
                        {/*     }}*/}
                        {/*>*/}
                        {/*    {activeColorItem && <div className={"product-card-thumb"}>*/}
                        {/*        <div className={"product-card-swatch"}*/}
                        {/*             style={{*/}
                        {/*                 backgroundColor: activeColorItem && activeColorItem.Hex,*/}
                        {/*                 backgroundImage: (activeColorItem && activeColorItem.Hex) ? "none" : null*/}
                        {/*             }}*/}
                        {/*        >*/}
                        {/*            <i className="arrow-right"></i>*/}
                        {/*        </div>*/}
                        {/*    </div>}*/}
                        {/*</div>*/}
                        {/*<div className="product-card-siblings">*/}
                        {/*    {filteredVariants.map((item, itemIndex) => {*/}


                        {/*        const colorItem = (colorFilter)*/}
                        {/*            ? navigation.colors.find(x => x.ColorId === item.Properties[colorFilter.GroupKey])*/}
                        {/*            : null;*/}

                        {/*        return (<div key={itemIndex} className={"product-card-thumb"}*/}
                        {/*                     onClick={(e) => navigation.deviceIsTouchEnabled ? this.toggleCard(e, {activeVariant: [{"GroupKey": groupByKey, "GroupValue": item.GroupKey}]}) : null}*/}
                        {/*                     onMouseOver={(e) => !navigation.deviceIsTouchEnabled && this.toggleCard(e, {activeVariant: [{"GroupKey": groupByKey, "GroupValue": item.GroupKey}]})}*/}
                        {/*                     onMouseLeave={(e) => !navigation.deviceIsTouchEnabled && this.toggleCard(e, {activeVariant: []})}*/}
                        {/*        >*/}
                        {/*            <div className={"product-card-swatch"}*/}
                        {/*                 style={{*/}
                        {/*                     backgroundColor: colorItem && colorItem.Hex,*/}
                        {/*                     backgroundImage: (colorItem && colorItem.Hex) ? "none" : null*/}
                        {/*                 }}></div>*/}
                        {/*        </div>);*/}


                        {/*    })}*/}
                        {/*</div>*/}
                    </div>

                    <div className="product-card-brand">{productBrand || ""}</div>
                    {/*<h3 className="product-card-heading"></h3>*/}
                    <div className="product-card-name">{productName} </div>
                    {!navigation.isD2C &&
                        <div className="product-card-sku">{productSku}, Packstorlek ({this.state.increments})
                        </div>}


                </a>
                <div className="product-card-bottom">
                    <div className="product-card-actions">


                        <QuantityEdit

                            key={this.state.sku + "_" + this.state.variantSku}
                            orderStore={this.props.store.order}
                            sku={this.state.sku}
                            variantSku={this.state.variantSku}
                            //quantity={this.state.quantity}
                            increments={this.state.increments}
                            //useTextAddButton={true}
                            textAddButton={textAddButton}
                            disabled={!addButtonEnabled}
                            productUrl={this.getProductUrl(product, currentUrlSlug)}

                        />
                    </div>
                    <div className="product-card-price">

                        {false && product.PriceFormatted !== "-"
                            ? <button
                                className="product-button-purchase"
                                disabled={!inStock}

                                onClick={(e) => this.increaseQuantities(
                                    e,
                                    [
                                        {
                                            Sku: product.Sku,
                                            VariantSku: null,
                                            AddQuantity: 1,
                                            ProductUrl: this.props.store
                                                .navigation.mainRouter
                                                .location.pathname
                                        }
                                    ])}
                            >
                                {inStock
                                    ? navigation.dictionary.AddTo
                                    : navigation.dictionary.NotInStock}

                                {inStock
                                    ? <FontAwesomeIcon icon={[
                                        "fas", "shopping-bag"
                                    ]} className="bag"/>
                                    : null}
                                <span key={"count_1"} className={classnames("count",
                                    {
                                        'visible': this.state.adding ===
                                            product.Sku
                                    })
                                }><span className="count-text">+1</span></span>

                            </button>
                            : null}

                        
                        {product.ListPrice !== product.Price &&
                            <span className="product-card-listprice-value">
                                {navigation.isD2C
                                    ? product.ListPriceFormatted
                                    : product.ListPriceExFormatted} {product.Currency}
                            </span>
                        }

                        <span key={"product_card_price"} className={"product-card-price-value " +
                            (product.ListPrice !== product.Price
                                ? "product-card-price-discounted"
                                : "")}>
                                    {navigation.isD2C
                                        ? product.PriceFormatted
                                        : product.PriceExFormatted} {product.Currency}
                                </span>
                    </div>
              
                </div>

            </React.Fragment>
        );
    }
}